import { InjectionToken } from '@angular/core';

export const IS_SERVER_BOT = new InjectionToken<boolean>('isServerBot');

export interface WebCommonConfig {
  newRelic?: {
    enabled?: string;
    applicationID?: string;
    licenseKey?: string;
    trustKey?: string;
    accountID?: string;
    agentID?: string;
  };
  autocompleteCategoriesSize?: number;
  autocompleteProductsSize?: number;
  autocompleteRecipesSize?: number;
  displayExtraLegals?: boolean;
  analytics?: {
    country?: { [baseSiteId: string]: string };
    error?: { [pageError: string]: string };
    siteEnv?: string;
  };
  debug?: boolean;
  occBaseUrl?: string;
  inlineTranslation?: boolean;
  inMaintenance?: boolean;
  components?: {
    benefits?: {
      show: boolean;
    };
    reinsurance?: {
      textConfig?: string;
      hasSubline?: boolean;
    };
    suitable?: {
      border?: boolean;
    };
    textQuote?: {
      defaultPicto?: string;
    };
    productHero?: {
      defaultBackgroundColor?: string;
    };
    breadcrumbs?: {
      separator?: string;
    };
    comparator?: {
      maxProducts?: {
        desktop?: number;
        mobile?: number;
      };
    };
    header?: {
      storeLocator?: {
        iconOnly?: boolean;
        isEnabled?: boolean;
      };
      help?: {
        iconOnly?: boolean;
        isEnabled?: boolean;
      };
    };
    pushSlider?: {
      sizeForce?: string;
    };
  };
  prudsys?: {
    host: string;
    reid: string;
  };
  pdp?: {
    defaultArgumentsMedia?: string;
    sizeGuide: {
      level2Families?: string;
      level1Families?: string;
    }
  };
  authentication?: {
    subDomain?: string;
    forcedBaseUrl?: string;
    clientId: string;
    expIdSuffix: string;
    expIdBrand: string;
    forcedExpId?: string;
  };
  myAccount?: {
    baseUrl: string;
    subscriptionKey: string;
    brand?: string;
  };
  dcp?: {
    baseUrl?: string;
    apiKey?: string;
  };
  bynder?: {
    baseUrl?: string;
    key?: string;
    token?: string;
    lang?: { [activeLang: string]: string };
  };
  refsav?: {
    baseUrl?: string;
    key?: string;
  };
  twicpics?: {
    isEnabled: boolean;
    forcedDomain?: string;
  };
  zoovu?: {
    baseUrl?: string;
  };
  cartRestriction?: boolean;
  DAM?: {
    baseUrl?: string;
    token?: string;
  };
  avisVerifies?: {
    baseUrl?: string;
    key?: string;
  };
  PDP_CACHE_DURATION?: {
    bot?: number;
    client?: number;
  };
  RECIPE_CACHE_DURATION?: {
    bot?: number;
    client?: number;
  };
  HOME_CACHE_DURATION?: {
    bot?: number;
    client?: number;
  };
  DEFAULT_CACHE_DURATION?: {
    bot?: number;
    client?: number;
  };
  nShift?: {
    baseUrl?: string;
    token?: string;
    checkoutId?: string;
  };
  shipup?: {
    returnPageUrl?: string
  };
  dqe?: {
    baseUrl?: string;
    licence?: string;
    subscriptionKey?: string;
  };
  extendedWarranty?: {
    baseUrl?: string;
    itemsToDisplay?: string;
    cache?: string;
    subscriptionKey?: string;
  };
  brandCorner?: {
    logo?: {
      krups?: string;
      rowenta?: string;
      tefal?: string;
      moulinex?: string;
      calor?: string;
      seb?: string;
    }
  };
  mock?: boolean;
  isUrlMappingLog?: boolean;
  seo?: {
    pattern?: {
      bundle?: {
        titleTag?: string;
      }
    }
  };
  script?: {
    url?: {
      shoppableContent?: string;
    }
  };
  referAFriend?: {
    brandSFMC?: string;
    endPointUrl?: string;
    pageLabel?: string;
  };
  doubleCurrency?: {
    [baseSiteId: string]: {
      enabled?: boolean;
      currencies?: {
        [currencyCode: string]: {
          exchange: {
            rate: number;
            targetIsoCode: string;
          }
        }
      };
      exchange?: {
        rate?: number;
      };
    }
  };
  abandonedCart?: {
    idleTimerDelay?: string;
    sessionTimerDelay?: string;
  };
  invoice?: {
    sis?: {
      enabled?: boolean
    }
  }
}
